import React from 'react'

import { useTranslation } from 'react-i18next'

import { Input, PasswordInput as RawPasswordInput } from '@cash-design-system/react'

export const PasswordInput = React.forwardRef<HTMLInputElement, React.ComponentProps<typeof Input>>((props, ref) => {
  const { t } = useTranslation()
  return (
    <RawPasswordInput
      {...props}
      ref={ref}
      hidePasswordLabel={t('Hide password', { context: 'aria label for button to hide password in form field' })}
      showPasswordLabel={t('Show password', { context: 'aria label for button to show password in form field' })}
    />
  )
})
